"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTogglePaymentModal = void 0;
const BalanceProvider_1 = require("astra-core/containers/BalanceProvider");
const react_1 = require("react");
const hooks_1 = require("../../../store/hooks");
const useTogglePaymentModal = () => {
    const dispatch = (0, hooks_1.useAppDispatch)();
    const togglePaymentModal = (0, react_1.useCallback)((paymentModalType) => {
        dispatch(BalanceProvider_1.balanceProviderActions.togglePaymentModal({ paymentModalType }));
    }, [dispatch]);
    return togglePaymentModal;
};
exports.useTogglePaymentModal = useTogglePaymentModal;
//# sourceMappingURL=useTogglePaymentModal.js.map